import { inject, Injectable } from '@angular/core';
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '../session/app-session.service';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionConsts } from '@shared/permission-consts';

@Injectable()
export class CompanyOrPublicRouteGuard {
    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this._sessionService.user) {
            return true;
        }

        if (this._permissionChecker.isGranted(PermissionConsts.PagesMyProfileCompany)) {
            return true;
        }

        this._router.navigate(['/app/homepage']);
        return false;
    }
}

export const companyOrPublicRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(CompanyOrPublicRouteGuard).canActivate(route, state);
};
